import Vue from "vue";
import Vuex from "vuex";
import { getField, updateField } from 'vuex-map-fields';

import engine from './modules/engine';
import scene from './modules/scene';
import ui from './modules/ui';

import config from '../config';

Vue.use(Vuex);

export default {
  modules: {
    engine,
    scene,
    ui,
  },
  state: {
    config,
  },
  getters: {
    getField,
    isDevelopment: state => process.env.NODE_ENV === "development",
    // TODO: relies on 'single' key at the moment as we only have one set of copy at the moment. If this changes in future add cohabiting copy in client config and make this getter rely on the cohabiting key instead of 'single'
    getQuestionAnswerData: state => key => state.config.questionAnswerData.single[key],
  },
  mutations: {
    updateField,
  },
};
